// Хуки для управления приглашениями
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import * as invitesApi from '@/api/invites'

export const useInvites = (statusFilter?: string) => {
  return useQuery({
    queryKey: ['invites', statusFilter],
    queryFn: () => invitesApi.fetchInvites(statusFilter),
  })
}

export const useCreateInvite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: invitesApi.createInvite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invites'] })
      message.success('Приглашение создано')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка создания приглашения')
    },
  })
}

export const useRevokeInvite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: invitesApi.revokeInvite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['invites'] })
      message.success('Приглашение отозвано')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка отзыва приглашения')
    },
  })
}
